import type { CleaningPrestation } from '@wecasa/common/src/types/commons';
import colors from '@wecasa/common/src/utils/colors';
import { formatPrice, formatPricePerHour } from '@wecasa/common/src/utils/formatting';

import type { BasketState } from '@wecasa/customer/src/ducks/types';
import type { Price } from '@wecasa/customer/src/types/prices';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

const t = translate('basket.membership.card');

type MemberWithSpotPrestationProps = {
  reduction: Price;
  duration: BasketState['duration'];
  cleaningPrestation?: CleaningPrestation;
};

const MemberWithSpotPrestation = ({ reduction, duration, cleaningPrestation }: MemberWithSpotPrestationProps) => {
  const cleaningPrestationTitle = cleaningPrestation?.title.toLowerCase() || '';

  return (
    <span>
      <Text.SMMedium>{t('.cleaning.spot.is_member.text_1')}</Text.SMMedium>
      <Text.SMBold color={colors.pink120}>
        {` ${duration ? formatPrice(reduction.price) : formatPricePerHour(reduction.hourly_price, { precision: 0 })} `}
      </Text.SMBold>
      <Text.SMMedium>{t('.cleaning.spot.is_member.text_2', { prestation: cleaningPrestationTitle })}</Text.SMMedium>
    </span>
  );
};

export default MemberWithSpotPrestation;
